import React, { useEffect, useState } from 'react';
import { 
  Frame, 
  Navigation,
  Button,
  Text,
  useBreakpoints
} from '@shopify/polaris';
import { 
  HomeIcon, 
  ProductIcon, 
  OrderIcon,
  AppsIcon,
  CalendarIcon,
  DeliveryIcon,
  MenuIcon
} from '@shopify/polaris-icons';

const AppNavigation = ({ 
  currentPage, 
  onNavigate, 
  children
}) => {
  const { mdDown: isMobile } = useBreakpoints();
  const [mobileNavigationOpen, setMobileNavigationOpen] = useState(false);

  useEffect(() => {
    setMobileNavigationOpen(false);
  }, [currentPage, isMobile]);

  const handleNavigate = (url) => {
    setMobileNavigationOpen(false);
    onNavigate(url);
  };

  const navigationItems = [
    {
      label: 'Dashboard',
      icon: HomeIcon,
      url: '/',
      selected: currentPage === 'dashboard'
    },
    {
      label: 'Products',
      icon: ProductIcon,
      url: '/products',
      selected: currentPage === 'products'
    },
    {
      label: 'Conditions',
      icon: ProductIcon,
      url: '/conditions',
      selected: currentPage === 'conditions'
    },
    {
      label: 'Add-Ons',
      icon: AppsIcon,
      url: '/addons',
      selected: currentPage === 'addons'
    },
    {
      label: 'Rentals',
      icon: OrderIcon,
      url: '/rentals',
      selected: currentPage === 'rentals'
    },
    {
      label: 'Upcoming Rentals',
      icon: CalendarIcon,
      url: '/current-rentals',
      selected: currentPage === 'current-rentals'
    },
    {
      label: 'Currently Rented Out',
      icon: DeliveryIcon,
      url: '/currently-rented-out',
      selected: currentPage === 'currently-rented-out'
    }
  ];

  return (
    <Frame
      topBar={isMobile ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', height: '100%', padding: '0 16px', background: 'var(--p-color-bg-surface)', borderBottom: '1px solid var(--p-color-border)' }}>
          <Button
            icon={MenuIcon}
            size="large"
            onClick={() => setMobileNavigationOpen(open => !open)}
            ariaControls="AppFrameNav"
            ariaExpanded={mobileNavigationOpen}
          >
            Menu
          </Button>
          <Text as="span" variant="headingSm">DropKid Rentals</Text>
        </div>
      ) : undefined}
      showMobileNavigation={mobileNavigationOpen}
      onNavigationDismiss={() => setMobileNavigationOpen(false)}
      navigation={
        <Navigation location={currentPage}>
          <Navigation.Section
            items={navigationItems.map(item => ({
              ...item,
              onClick: () => handleNavigate(item.url),
              selected: item.selected
            }))}
          />
        </Navigation>
      }
    >
      {children}
    </Frame>
  );
};

export default AppNavigation;
